export const stripe = {
  subTitle:
    "Vincule sua conta Stripe para cobrar seus clientes pelas reservas de forma rápida e fácil, evitando as comissões das agências de viagens online.",
};
